// extracted by mini-css-extract-plugin
export default {"root":"IntegrationExample--root--3m9AC"};